/**
 * A custom element that handles hover-based product panel switching in the mega menu.
 * When a link with [data-collection-handle] is hovered, the corresponding
 * [data-hover-panel] product grid is shown and all others are hidden.
 */
class MegaMenuHover extends HTMLElement {
  /** @type {AbortController} */
  #abortController;

  connectedCallback() {
    this.#abortController = new AbortController();
    const signal = this.#abortController.signal;

    const links = this.querySelectorAll('[data-collection-handle]');
    links.forEach((link) => {
      link.addEventListener('pointerenter', () => this.#activate(link), { signal });
    });
  }

  disconnectedCallback() {
    this.#abortController?.abort();
  }

  /**
   * Activate the panel matching the hovered link's collection handle.
   * @param {Element} link
   */
  #activate(link) {
    const handle = link.getAttribute('data-collection-handle');
    if (!handle) return;

    // Update active link
    const allLinks = this.querySelectorAll('[data-collection-handle]');
    allLinks.forEach((l) => l.classList.remove('mega-menu__hover-link--active'));
    link.classList.add('mega-menu__hover-link--active');

    // Update active panel
    const allPanels = this.querySelectorAll('[data-hover-panel]');
    allPanels.forEach((panel) => {
      if (panel.getAttribute('data-hover-panel') === handle) {
        panel.classList.add('mega-menu__hover-panel--active');
      } else {
        panel.classList.remove('mega-menu__hover-panel--active');
      }
    });
  }
}

if (!customElements.get('mega-menu-hover')) {
  customElements.define('mega-menu-hover', MegaMenuHover);
}
